export interface MessageConversation {
  id: number;
  name: string;
  preview: string;
  time: string;
  unread: number;
  avatar: string;
  color: string;
  online: boolean;
}

export type ChatSender = 'patient' | 'practice';

export interface ChatMessage {
  from: ChatSender;
  text: string;
  time: string;
}

/** Fil de discussion démo par conversation (orthodontie). */
export const MESSAGE_THREADS: Record<number, ChatMessage[]> = {
  1: [
    {
      from: 'patient',
      text: 'Bonjour Docteur, une attache s’est décollée sur la 2ᵉ molaire en bas à droite.',
      time: '09:35',
    },
    {
      from: 'patient',
      text: 'Est-ce urgent ou puis-je attendre mon RDV de contention jeudi ?',
      time: '09:36',
    },
    {
      from: 'practice',
      text: 'Bonjour Sophie, ce n’est pas urgent si la gouttière d’aligneurs tient bien. On recollera jeudi à 16 h.',
      time: '09:40',
    },
    {
      from: 'patient',
      text: 'Parfait, merci. Je garde la gouttière toute la journée comme d’habitude.',
      time: '09:42',
    },
  ],
  2: [
    {
      from: 'patient',
      text: 'Merci pour le contrôle du mois, les dents bougent bien je trouve.',
      time: '08:55',
    },
    {
      from: 'practice',
      text: 'Avec plaisir Marc. Continuez les élastiques classe II 14 h/jour jusqu’à jeudi prochain.',
      time: '09:01',
    },
    {
      from: 'patient',
      text: 'Noté, à jeudi 14 h pour la prochaine activation.',
      time: '09:03',
    },
  ],
  3: [
    {
      from: 'patient',
      text: 'Bonjour, je n’arrive pas à porter les élastiques la nuit, ça tire trop sur la mâchoire.',
      time: 'hier 16:22',
    },
    {
      from: 'practice',
      text: 'Bonjour Élodie, commencez par 4 h en soirée sur 3 jours, puis augmentez d’une heure par jour.',
      time: 'hier 17:05',
    },
  ],
  4: [
    {
      from: 'patient',
      text: 'Confirmé pour le RDV de 10 h : activation et changement d’arc.',
      time: 'hier 11:20',
    },
    {
      from: 'practice',
      text: 'Parfait Julien, pensez à brosser bien avant le rendez-vous. À tout à l’heure.',
      time: 'hier 11:24',
    },
  ],
  5: [
    {
      from: 'patient',
      text: 'Pourriez-vous m’envoyer le compte-rendu du bilan initial et le devis du traitement multi-attaches ?',
      time: '2 j',
    },
    {
      from: 'practice',
      text: 'Bonjour Anne, documents envoyés sur votre espace patient. N’hésitez pas si vous avez des questions sur les phases.',
      time: '2 j',
    },
  ],
  6: [
    {
      from: 'patient',
      text: 'Photos de surveillance envoyées ce matin (face, profil, sourire).',
      time: '2 j',
    },
    {
      from: 'practice',
      text: 'Merci Inès, alignement conforme à la 8ᵉ gouttière. On valide le passage à la 9ᵉ lundi.',
      time: '2 j',
    },
    {
      from: 'patient',
      text: 'Parfait, à lundi prochain. Belle journée !',
      time: '2 j',
    },
  ],
  7: [
    {
      from: 'patient',
      text: 'Les tensions après l’activation d’hier sont plus fortes que d’habitude, c’est normal ?',
      time: '3 j',
    },
    {
      from: 'practice',
      text: 'Bonjour Paul, oui pendant 48–72 h après un changement d’arc. Paracétamol si besoin, pas d’aspirine.',
      time: '3 j',
    },
    {
      from: 'patient',
      text: 'Merci, c’est déjà beaucoup mieux ce matin.',
      time: '3 j',
    },
  ],
};

export const MESSAGE_CONVERSATIONS: MessageConversation[] = [
  {
    id: 1,
    name: 'Sophie Bernard',
    preview: 'Une attache s’est décollée sur la 2ᵉ molaire…',
    time: '09:42',
    unread: 2,
    avatar: 'SB',
    color: '#fb923c',
    online: true,
  },
  {
    id: 2,
    name: 'Marc Dubois',
    preview: 'Continuez les élastiques classe II 14 h/jour…',
    time: '09:03',
    unread: 0,
    avatar: 'MD',
    color: '#60a5fa',
    online: false,
  },
  {
    id: 3,
    name: 'Élodie Garcia',
    preview: 'Je n’arrive pas à porter les élastiques la nuit…',
    time: 'hier',
    unread: 1,
    avatar: 'EG',
    color: '#a78bfa',
    online: false,
  },
  {
    id: 4,
    name: 'Julien Petit',
    preview: 'Confirmé pour le RDV de 10 h : activation…',
    time: 'hier',
    unread: 0,
    avatar: 'JP',
    color: '#34d399',
    online: true,
  },
  {
    id: 5,
    name: 'Anne Rousseau',
    preview: 'Compte-rendu du bilan initial et devis multi-attaches',
    time: '2 j',
    unread: 0,
    avatar: 'AR',
    color: '#f472b6',
    online: false,
  },
  {
    id: 6,
    name: 'Inès Caron',
    preview: 'Alignement conforme à la 8ᵉ gouttière',
    time: '2 j',
    unread: 0,
    avatar: 'IC',
    color: '#22d3ee',
    online: false,
  },
  {
    id: 7,
    name: 'Paul Lemaire',
    preview: 'Tensions après activation, c’est normal ?',
    time: '3 j',
    unread: 0,
    avatar: 'PL',
    color: '#fb7185',
    online: false,
  },
];

export function conversationIdByName(name: string): number | undefined {
  return MESSAGE_CONVERSATIONS.find((c) => c.name === name)?.id;
}

function hashName(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

/** Deterministically picks a conversation for a given patient name. */
export function conversationForPatient(name: string): MessageConversation {
  const direct = MESSAGE_CONVERSATIONS.find((c) => c.name === name);
  if (direct) return direct;
  const idx = hashName(name) % MESSAGE_CONVERSATIONS.length;
  return MESSAGE_CONVERSATIONS[idx]!;
}
